<template>
  <a-card class="section_item">
    <div class="section_item--content">
      <slot v-if="hasEditSlot && internalChecked" name="edit"></slot>
      <div v-else>
        <p class="section_item--text">
          {{ title }}
          <a-tooltip v-if="tooltip">
            <template #title>
              {{ tooltip }}
            </template>
            <InfoCircleOutlined style="margin-left: 5px" />
          </a-tooltip>
        </p>
        <p class="section_item--value">
          {{ messageValue }}
        </p>
      </div>
      <div v-if="messageInfo || messagePersonalized">
        <p class="section_item--info" v-if="!personalized">
          {{ messageInfo }}
        </p>
        <p class="section_item--personalized" v-else>
          {{ messagePersonalized }}
          <a-switch
            size="small"
            :checked="internalChecked"
            @change="handleChangeChecked"
          />
        </p>
      </div>
    </div>
  </a-card>
</template>

<script setup lang="ts">
import { ref, useSlots, watch } from "vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";

const props = defineProps({
  title: {
    type: String,
  },
  tooltip: {
    type: String,
    required: false,
  },
  value: {
    default: null,
  },
  messageValue: {
    type: String,
  },
  messageInfo: {
    type: String,
  },
  customizable: {
    type: Boolean,
    default: false,
    required: false,
  },
  allowActivate: {
    type: Boolean,
    default: false,
    required: false,
  },
  personalized: {
    type: Boolean,
    default: false,
    required: false,
  },
  messagePersonalized: {
    type: String,
  },
  checked: {
    type: Boolean,
    default: false,
    required: false,
  },
});

const internalChecked = ref(props.checked);
const slots = useSlots();
const hasEditSlot = !!slots.edit;

const emit = defineEmits(["update:checked"]);

const handleChangeChecked = (newValue: boolean) => {
  internalChecked.value = newValue;
  emit("update:checked", newValue);
};

watch(() => props.checked, (newChecked) => {
  internalChecked.value = newChecked;
});
</script>

<style lang="sass" scoped>
p
  margin: 0
.section
  margin-top: 25px
  h4
    margin: 10px 0
  &_item
    border: 1px solid #00000026
    margin-top: 8px
    .ant-card-body
      padding: 10px 15px
      // background-color: #00000005
    &--content
      width: 100%
      display: flex
      justify-content: space-between
      align-items: center
      gap: 15px
    &--value
      font-weight: 600
    &--text
      display: flex
      align-items: center
      justify-content: space-between
      .anticon
        margin-left: 5px
    &--info
      color: $gray-7
    &--personalized
      display: flex
      align-items: center
      gap: 8px
</style>